import type { ReactNode } from 'react'
import { OrgSwitchProvider } from './OrgSwitchContext'
import { OrgSwitchLoadingOverlay } from './OrgSwitchLoadingOverlay'
import { useOrgSwitchReadyCoordinator } from './useOrgSwitchReadyCoordinator'

function OrgSwitchCoordinatorMount(): null {
  useOrgSwitchReadyCoordinator()
  return null
}

/**
 * App-level org switch UI + coordinator. Wrap authenticated route tree inside OrgTenantProvider.
 */
export function OrgSwitchShell({ children }: { children: ReactNode }) {
  return (
    <OrgSwitchProvider>
      <OrgSwitchCoordinatorMount />
      <OrgSwitchLoadingOverlay />
      {children}
    </OrgSwitchProvider>
  )
}
